/**
 * package:
 * class: Application
 * @extends com.inq.ui.SkinLoader
 * @constructor
 */
window.Application = function() {
	com.inq.ui.Container.call(this);
    com.inq.utils.ConsoleLogger.redirectTraces();
	this.skinLoader = new com.inq.ui.SkinLoader(this);
	this.applicationController = null;
	this.area = new com.inq.utils.Area(0,0,0,0);
	this.initialized = false;
	/** @type {Element} */
	var oldContainer = document.getElementById("Skin");
	if (oldContainer) {
		oldContainer.parentNode.removeChild(oldContainer);
	}
	var oldContainerDivSkin = document.getElementById("tcChat_Skin");
	if (oldContainerDivSkin) {
		oldContainerDivSkin.parentNode.removeChild(oldContainerDivSkin);
	}
	this.url = js.Lib.document.getElementById("inqChatJs").src;
	/** @type {Array} */
	var aPath = this.url.split("\\").join("/").split("/");
	aPath.pop();
	this.path = aPath.join("/");
	this.initializeParameters();
	this.preventChatClose = false;
	this.screen = new com.inq.ui.Screen();
	this.stage = com.inq.ui.Stage.getInstance();
	this.titlebar = new com.inq.ui.Image("inqTitleBar");
	/** @type {Array} */
	this.styleLinksList = [];
	if(!this.panelWindow)
		this.setPanelWindow(window);

	/*  Set correct title bar height. (Should match what's in DB, and thus in FlashPeer.) */
	/** @type {Element} */
	var inqTitleBar = com.inq.ui.Container._getElementById("inqTitleBar",window.parent.document);
	if(inqTitleBar == null) {
		inqTitleBar = window.parent.document.createElement("DIV");
		inqTitleBar.id = "inqTitleBar";
		inqTitleBar.style = "position: absolute; z-index: 9999999; height: 1px; width: 1px; left: 0px; top: 0px;";
		window.parent.document.body.appendChild(inqTitleBar);
	}
	inqTitleBar.style.height = com.inq.flash.client.chatskins.SkinControl.getTitleBarHeight() + "px";

	/**
	 * RTDEV-7155 note:
	 * If HTML element is empty (even if it have any elements that are visible but their sizes are nil)
	 * then such element considered to be invisible to the action in IE10 and earlier versions.
	 * Therefore we should set specified style for this element.
	 */
// TODO -DL-
//	inqTitleBar.style["background-image"] = "url(" + this.getImagePath() + "clear.gif)";
	/** @type {string} */
	var clearImage = "";
	if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
		clearImage = com.inq.flash.client.control.FlashPeer.getSkinPath() + "/" + com.inq.flash.client.control.FlashPeer.getSkinName() + "/clear.gif"
	}
	else {
	    clearImage = this.getImagePath() + "clear.gif"
	}

	this["clearImage"] = clearImage;/*  Register the clear gif with the application*/
	this.titlebar.setID("inqTitleBar");
	this.titlebar.initStyle("cursor","move");
	this.titlebar.initStyle("borderThickness","0");
	this.titlebar.initStyle("top","0");
	this.titlebar.initStyle("left","0");

	try {
		this.titlebar.initStyle("right","" + com.inq.flash.client.control.FlashPeer.getPopupCloserWidth());
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			this.titlebar.initStyle("right","52");
		} else throw(e);
	}
	try {
		this.titlebar.initStyle("height","" + com.inq.flash.client.chatskins.SkinControl.getTitleBarHeight());
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "Application.hx", lineNumber : 103, className : "Application", methodName : "new"});
		} else throw(e);
	}
	this.titlebar.setStyle("zIndex",Application.zIndexResize);

	/* Test for input image in titlebar div */
	/** @type {NodeList} */
	var inputList = this.titlebar._div.getElementsByTagName("INPUT");
	if (inputList == null || inputList.length == 0) {
// TODO -DL-
		this.titlebar._div.innerHTML = "<input type=\"image\" src=\"" + clearImage + "\" style=\"height: 100%; width: 100%;\" alt=\"\" tabindex=\"-1\"/>";
	}
	if (window.parent.name == "_inqPersistentChat" || com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		this.titlebar.setVisible(false);
		this.resizeCorner = null;
	} else {
		this.resizeCorner = buildResizeCorner(this.getImagePath());

		/**
		 * RTDEV-7155 note:
		 * If HTML element is empty (even if it have any elements that are visible but their sizes are nil)
		 * then such element considered to be invisible to the action in IE10 and earlier versions.
		 * Therefore we should set specified style for this element.
		 *
		 * If we are a phone, buildResizeCorner returns null, so this.resizeCorner will be null.
		 */
	}


	this.onApplicationControllerInitializedHandlers = new Array();

	/**
	 * setVisibleResizeCorner
	 *
	 *  Wrapper of this.resizeCorner.setVisible to prevent exception in case this.resizeCorner is null (phone).
	 *
	 * @public
	 * @param {boolean} bVisible
	 */
	this.setVisibleResizeCorner = function(bVisible) {
		if (this.resizeCorner !== null) {
			this.resizeCorner.setVisible(bVisible);
		}
	};

	/**
	 * setVisibleResizeCorner
	 *
	 *  Wrapper of this.resizeCorner.move2Stage to prevent exception in case this.resizeCorner is null (phone).
	 *
	 * @see   resizeCorner.move2Stage
	 * @public
	 * @param {number} left
	 * @param {number} top
	 * @param {number} w
	 * @param {number} h
	 */
	this.moveResizeCorner2Stage = function (left, top, w, h) {
		if (this.resizeCorner !== null) {
			this.resizeCorner.move2Stage(left, top, w, h);
		}
	};

	Application.prototype.setPreventChatClosed = function (value) {
		this.preventChatClose = value;
	};

	Application.prototype.getPreventChatClosed = function () {
		return this.preventChatClose;
	};


	/**
	 * buildResizeCorner
	 *
	 *  resizeCorner is a special DOM object located at the bottom right corner of a chat window
	 *  let user resize chat window.
	 *
	 * @private
	 * @return {com.inq.ui.Image}
	 */
	function buildResizeCorner(imagePath) {

		var resizeCorner = null;

		// On Phones, there is no resize button.
		if( !com.inq.utils.Capabilities.isPhone() ) {
			resizeCorner = new com.inq.ui.Image("inqDivResizeCorner");
		}

		// Apply style on the resizeCorner instance.
		if(resizeCorner != null) {
			resizeCorner.setID("inqDivResizeCorner");
			resizeCorner.initStyle("cursor","se-resize");
			resizeCorner.initStyle("borderThickness","0");
			resizeCorner.initStyle("right","0");
			resizeCorner.initStyle("bottom","0");
			resizeCorner.initStyle("width",Application.dragArea.w);
			resizeCorner.initStyle("height",Application.dragArea.h);

			/*  Make sure that the corner stays ABOVE the title bar.*/
			resizeCorner.setStyle("zIndex",Application.zIndexResize + 1);

			/* resizeCorner should not be detected by a screen reader */
			resizeCorner._div.setAttribute("alt", "");
			resizeCorner._div.setAttribute("aria-hidden", "true");
			resizeCorner._div.setAttribute("tabindex", "-1");

			/*  Since the draggable div might be bigger than the image, pin the image to the bottom right. */
			/** @type {DOM input} */ var inputList1 = resizeCorner._div.getElementsByTagName("INPUT");
			if(inputList1 == null || inputList1.length == 0) {
				resizeCorner._div.innerHTML = "<input type=\"image\" src=\"" + imagePath + "ResizeCorner.gif" + "?rand=" + Math.random() + "\""
					+ "style=\"position: absolute; top:0px; left:0px; height: 100%; width: 100%; bottom: 0px; right: 0px; display: block;\" tabindex=\"-1\"/>";
			}

			// override
			resizeCorner.setVisible = function(bVisible) {
				this._div.style.display = bVisible ? "block":"none";
			};

			/**
			 * move2Stage
			 *
			 *  Move resizeCorner to right location.
			 *
			 * @this   resizeCorner
			 * @public
			 * @static
			 * @param {number} left relLeft
			 * @param {number} top relTop
			 * @param {number} w
			 * @param {number} h
			 * @return {void}
			 */
			resizeCorner.move2Stage = function(left, top, w, h) {
				this._div.style.left = left + w - Application.dragArea.w + "px";
				this._div.style.top = top + h - Application.dragArea.h + "px";
				this._div.style.width = Application.dragArea.w + "px";
				this._div.style.height = Application.dragArea.h + "px";
				this._div.style.display = Application.resizable && Application.application.getVisible()?"block":"none";
				if(!Application.resizable){
					this._div.style.visibility = "collapse";
				}
				/*  Make sure the resize corner stays ABOVE the title bar.*/
				this._div.style.zIndex = Application.zIndexResize + 1;
			}
		}
		return resizeCorner;
	}

	com.inq.flash.client.chatskins.SndMgr._init(); // remove soundDiv to fix 'Sound in Chatskin plays in Firefox when you click on the "Click to Chat button".'
};
$hxClasses.extend(com.inq.ui.Container, Application, "Application");

/** @private @type {string} */
Application.mxml = null;
/** @private @type {Array} */
Application.containsOutside = null;
/** @private @type {com.inq.ui.Container} */
Application.me = null;

/**
 * This function specifies the coordinates of the chat when the page is scrolled,
 * and it is also called when the chat is moved (drag event). Also this function
 * calling reposition for "div" to resize chat.
 *
 * @public
 * @static
 * @param {number}  relLeft correction chat position on left.
 * @param {number}  relTop correction chat position on top.
 * @param {boolean=} wasDragged true if it is drag event and undefined if not.
 * @return {void}
 */
Application.ScrollStage = function(relLeft,relTop, wasDragged) {
	/** @type {number} */
	var w;
	/** @type {number} */
	var h;
	/** @type {number} */
	var l;
	/** @type {number} */
	var t;
	/** @type {Element} */
	var iframe = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ? Application.application.stg
		: Application.IsPersistent() && com.inq.utils.Capabilities.isIpad() ? Application.application._div
					 : js.Lib.window.frameElement;
	/** @type {com.inq.utils.Area} object which represents our viewport */
	var vp = com.inq.utils.Capabilities.getViewport();

	w = Std.parseInt(iframe.style.width);
	h = Std.parseInt(iframe.style.height);
	l = Std.parseInt(iframe.style.left);
	t = Std.parseInt(iframe.style.top);

	// When we have negative correction for our chat coordinates
	// we dont want apply it when our browser window less than chat window.
	if ((relLeft < 0 || relTop < 0) && (vp.x >= w && vp.y >= h)) {
		relLeft = 0;
		relTop = 0;
	}

	if ((parent.innerHeight > h && parent.innerWidth > w) || wasDragged) {
		l += relLeft;
		t += relTop;
		// We don't need corrected coordinates when it's drag event.
		if (!wasDragged) {
			l = Application.FixAbsoluteX(l, w);
			t = Application.FixAbsoluteY(t, h);
		}
		iframe.style.left = l + "px";
		iframe.style.top = t + "px";
		Application.MoveSizeDiv2Stage(w,h,l,t);
	}
};
/**
 * @public
 * @static
 * @param {number} left
 * @param {number} top
 * @return {void}
 */
Application.ScrollStageRelPage= function(left, top) {
	/** @type {HTMLFrameElement} */
	var iframe = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ? Application.application.stg : js.Lib.window.frameElement;
	/** @type {number} */
	var w = Std.parseInt(iframe.style.width);
	/** @type {number} */
	var h = Std.parseInt(iframe.style.height);
	iframe.style.left = left + "px";
	iframe.style.top = top + "px";
	Application.MoveSizeDiv2Stage(w, h, left, top)
}

/**
 * ScrollStageInPage
 * Move the stage, ensuring that it stays within the PAGE, not
 * necessarily the viewport.
 *
 * $type TFun([{ name => relLeft, t => TInst(Int,[]), opt => false },{ name => relTop, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * public static function ScrollStageInPage(relLeft:Int, relTop:Int)
 * @public
 * @static
 * @param {number}  relLeft
 * @param {number}  relTop
 * @return {void}
 */
Application.ScrollStageInPage = function(relLeft,relTop) {
	/** @type {Element} */
	var iframe = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ? Application.application.stg : js.Lib.window.frameElement;
	/** @type {number} */
	var w = Std.parseInt(iframe.style.width);
	/** @type {number} */
	var h = Std.parseInt(iframe.style.height);
	/** @type {number} */
	var l = Std.parseInt(iframe.style.left) + relLeft;
	/** @type {number} */
	var t = Std.parseInt(iframe.style.top) + relTop;

	/** @type {number} */
	var ow = Std.parseInt(window.parent.document.documentElement.offsetWidth);
	/** @type {number} */
	var oh = Math.max(Std.parseInt(window.parent.document.documentElement.offsetHeight),window.parent.document.body.clientHeight);

	/** @type {number} */
	var st = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
	/** @type {number} */
	var sl = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();

	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();

	/** @type {number} */
	var docMaxLeft = ow - w;
	/** @type {number} */
	var winMaxLeft = ow - sl + vp.w;

	/** @type {number} */
	var docMaxTop = oh - h;
	/** @type {number} */
	var winMaxTop = oh - st + vp.h;

	/** @type {number} */
	var maxLeft = docMaxLeft > winMaxLeft?docMaxLeft:winMaxLeft;
	/** @type {number} */
	var maxTop = docMaxTop > winMaxTop?docMaxTop:winMaxTop;

	l = l < 0?0:l;
	l = l > maxLeft?maxLeft:l;

	t = t < 0?0:t;
	t = t > maxTop?maxTop:t;

	iframe.style.left = l + "px";
	iframe.style.top = t + "px";
	Application.MoveSizeDiv2Stage(w,h,l,t);
};


/**
 * MoveSizeDiv2Stage
 *
 * $type TFun([{ name => w, t => TInst(Int,[]), opt => true },{ name => h, t => TInst(Int,[]), opt => true },{ name => left, t => TInst(Int,[]), opt => true },{ name => top, t => TInst(Int,[]), opt => true }],TEnum(Void,[]))
 * public static function MoveSizeDiv2Stage(?w:Int, ?h:Int, ?left:Int, ?top:Int)
 * @public
 * @static
 * @param {number}  w
 * @param {number}  h
 * @param {number}  left
 * @param {number}  top
 * @return {void}
 */
Application.MoveSizeDiv2Stage = function(w,h,left,top) {
    /* check value of width. */
    if(w == null) {
		w = com.inq.flash.client.control.PersistenceManager.GetValue(WIDTH, Application.DEFAULT_WIDTH_VAL);
		w = Std.parseInt(w);
        // This call is not necessary since persistenceManager returns default value.
        if(w == null) w = Application.application.area.w;
    }
    /*  ALWAYS enforce minimum dimensions configured in the skin. */
    if(w < Application.minWidth) w = Application.minWidth;

    if(h == null) {
		h = com.inq.flash.client.control.PersistenceManager.GetValue(HEIGHT, Application.DEFAULT_HEIGHT_VAL);
		h = Std.parseInt(h);

        if(h == null) h = Application.application.area.h;
    }
    if(h < Application.minHeight) h = Application.minHeight;

    if(top == null) top = Application.application.area.y;

    if(left == null) left = Application.application.area.x;


	/*  Remember our own dimensions. */
	Application.application.area = new com.inq.utils.Area(left,top,w,h);
	Application.application.setWidth(Application.application.area.w);
	Application.application.setHeight(Application.application.area.h);

	if(Application.application._div != null
		&& Application.application._div.ownerDocument != null
		&& Application.application._div.ownerDocument != window.document || com.inq.flash.client.control.FlashPeer.noV3FrameChat()) {
		/*Embedded chats should have minimum z-index value*/
		var zIndexVar = com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid() ? 1 : Application.zIndexResize;
		if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
			zIndexVar = zIndexVar - 1;
		}
		if (!com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			/* This repositions for move */
			Application.application._div.style.left = left + "px";
			Application.application._div.style.top = top + "px";
		}
		Application.application._div.style.zIndex = zIndexVar;
		/* This makes sure that we are repositioned after resize */
		Application.application.initStyle("top","" + top);
		Application.application.initStyle("left","" + left);
		Application.application.initStyle("width","" + w);
		Application.application.initStyle("height","" + h);
		Application.application.initStyle("overflow","hidden");
		Application.application.initStyle("z-index", "" + zIndexVar);
	}

	var clientDoc = parent.document;
	/** @type {Element} */
	var inqTitleBar = com.inq.ui.Container._getElementById("inqTitleBar", clientDoc);
	if(inqTitleBar) {
		inqTitleBar.style.left = left + "px";
		inqTitleBar.style.top = top + "px";
		/** @type {number} */
		var rightOffset = Application.application.titlebar.getStyle("right");
		inqTitleBar.style.width = w - rightOffset + "px";/*  Intentionally leaving the height alone here.*/

		if (com.inq.utils.Util.getConfig('dragAreaWidth')) {
			inqTitleBar.style.width = com.inq.utils.Util.getConfig('dragAreaWidth') + "px";
		}
		if (com.inq.utils.Util.getConfig('dragAreaHeight')) {
			inqTitleBar.style.height = com.inq.utils.Util.getConfig('dragAreaHeight') + "px";
		}

        if(!Application.draggable){
            inqTitleBar.style.visibility = "collapse";
        }
		inqTitleBar.style.zIndex = Application.zIndexResize;/* Safari drops z-index value and as the result, the title bar is not visible. */

		/*  Resize the input element along with the containing div. */
		try {
			/** @type {NodeList} */
			var inqTitleBarInput = inqTitleBar.getElementsByTagName("input")[0];
			if(inqTitleBarInput != null) {
				if (com.inq.utils.Util.getConfig('dragAreaWidth')) {
					inqTitleBar.style.width = com.inq.utils.Util.getConfig('dragAreaWidth') + "px";
				} else  {
					inqTitleBarInput.style.width = w - rightOffset + "px";
				}
			}
		} catch( e ) {
			haxe.Log.trace("ERROR: resizing input element in title bar: " + Std.string(e),{ fileName : "Application.hx", lineNumber : 379, className : "Application", methodName : "MoveSizeDiv2Stage"});
		}
	}

	if (!com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		/** @type {Object} */
		var oLeftTop = {};
		oLeftTop[LEFT] = left;
		oLeftTop[TOP] = top;
		com.inq.flash.client.control.PersistenceManager.SetValues(oLeftTop);
	}
	// relocate resizeCorner to the new location.
	Application.application.moveResizeCorner2Stage(left, top, w, h);
};


/**
 * FixAbsoluteX
 *
 * Returns chat window's x (horizontal) position in a client document.
 *
 * $type TFun([{ name => x, t => TInst(Int,[]), opt => false },{ name => w, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private static function FixAbsoluteX(x:Int, w:Int):Int
 * @private
 * @static
 * @param {number}  x - horizontal position relative to left of document.
 * @param {number}  w - width of chat interface.
 * @return {number} - horizontal position relative to left of document.
 */
Application.FixAbsoluteX = function(x,w) {
	/** @type {number} */
	var l;
	/** @type {number} */
	var scrollLeft = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
	l = x - scrollLeft;
	return Application.FixX(l,w) + scrollLeft;
};


/**
 * FixAbsoluteY
 *
 * $type TFun([{ name => y, t => TInst(Int,[]), opt => false },{ name => h, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private static function FixAbsoluteY(y:Int, h:Int):Int
 * @private
 * @static
 * @param {number}  y - vertical position relative to top of document.
 * @param {number}  h - height of chat interface.
 * @return {number} - vertical position relative to top of document.
 */
Application.FixAbsoluteY = function(y,h) {
	/** @type {number} */
	var t;
	/** @type {number} */
	var scrollTop;
	t = y - (scrollTop = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop());
	return Application.FixY(t,h) + scrollTop;
};


/**
 * FixX
 *
 * Return adjusted x position if necessary, based on w(width of chat window) and page width.
 *
 * TODO: the function does not consider when chat window is bigger than client page.
 *
 * $type TFun([{ name => x, t => TInst(Int,[]), opt => false },{ name => w, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private static function FixX(x:Int, w:Int):Int
 * @private
 * @static
 * @param {number}  x - horizontal position relative to left of viewport.
 * @param {number}  w - width of chat interface
 * @return {number} - horizontal position relative to left of viewport.
 */
Application.FixX = function(x,w) {
	/** @type {number} */
	var left = x < 0?0:x;
	/** @type {number} */
	var right = left + w;
	/** @type {number} */
	var xMax = com.inq.flash.client.chatskins.ScrollMonitor.getScrollWidth();
	if(right > xMax && left != 0) left = xMax - w;
	if(left < 0) left = 0;
	return left;
};


/**
 * FixY
 *
 * $type TFun([{ name => y, t => TInst(Int,[]), opt => false },{ name => h, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private static function FixY(y:Int, h:Int):Int
 * @private
 * @static
 * @param {number}  y - vertical position relative to top of viewport.
 * @param {number}  h - height of chat interface
 * @return {number} - vertical position relative to top of viewport.
 */
Application.FixY = function(y,h) {
	/** @type {number} */
	var top = y < 0?0:y;
	/** @type {number} */
	var scrollHeight = com.inq.flash.client.chatskins.ScrollMonitor.getScrollHeight();
	/* Make sure that the Y position allows the
	 * chat to be totally visible in the window.
	 * 1) get the height of the scroll area (viewport)
	 * 2) subtract the height to yield the maximum absolute position
	 * 3) adjust if greater than.
	 */

	/** @type {number} */
	var yMax = scrollHeight - h;

	if(top > yMax && top != 0) top = yMax;
	if(top < 0) top = 0;
	return top;
};


/**
 * SetArea - Sets the position and dimensions of the chat
 * interface.
 *
 * $type TFun([{ name => area, t => TInst(com.inq.utils.Area,[]), opt => false }],TEnum(Void,[]))
 * public static function SetArea(area:Area):Void
 * @public
 * @static
 * @param {com.inq.utils.Area}  area - An Area object indicating the desired position and dimensions of the CI.
 * @return {void}
 */
Application.SetArea = function(area) {
	if(com.inq.utils.Capabilities.isPhone()) {
		Application.application._div.style.top = "0px";
		Application.application._div.style.left = "0px";
		Application.ResizeStage(area.w,area.h);
		/* for phones, we do NOT want to move the stage, because the positioning is fixed and here is nothing to be gained by moving the stage except wasting gpu cycles */
	} else {
		Application.ResizeStage(area.w,area.h);
		Application.MoveStage(area.x,area.y);
	}
};


/**
 * IsPersistent
 * Provides system-wide visibility as to whether we're in
 * persistent mode.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function IsPersistent():Bool
 * @public
 * @static
 * @return {boolean}
 */
Application.IsPersistent = function() {
	return Application.isPersistent;
};


/**
 * GetArea - Retrieves the position and dimensions of the chat interface.
 *
 * $type TFun([],TInst(com.inq.utils.Area,[]))
 * public static function GetArea():Area
 * @public
 * @static
 * @return {com.inq.utils.Area} - an Area representing the current position and dimensions of the CI.
 */
Application.GetArea = function() {
	return Application.application.area.copy();
};


/**
 * The function sets the coordinates for the chat after it is moved (drag event),
 * if the page size more than chat size, chat coordinates will be adjusted so that
 * the chat does not go outside the page. Also, this function saves the chat coordinates
 * in cookies and calling moving on scroll page event.
 *
 * @public
 * @static
 * @param {number}  newLeft new chat position on left
 * @param {number}  newTop new chat position on left
 * @return {void}
 */
Application.MoveStage = function(newLeft,newTop) {
	var embeddedTheme = com.inq.flash.client.control.FlashPeer.getEmbeddedTheme();
	if (embeddedTheme && embeddedTheme.isValid) {
		return;
	}
	/** @type {Element} */
	var iframe = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ? Application.application.stg:js.Lib.window.frameElement;
	/** @type {number} */
	var w = Std.parseInt(iframe.style.width);
	/** @type {number} */
	var h = Std.parseInt(iframe.style.height);

	/* Let's make sure that we reference the labels as
	 * strings, because we are referencing cookie values
	 * which cannot survive code obfuscation from here
	 */
	/** @type {Object} */
	var oLeftTop = { };
	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	/** @type {number} */
	var adjustedLeft;
	/** @type {number} */
	var adjustedTop;
	/** @type {number} */
	var relLeft;
	/** @type {number} */
	var relTop;

	if (w < vp.w && h < vp.h) {
		newLeft -= com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
		newTop -= com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
		adjustedLeft = Application.FixX(newLeft, w);
		adjustedTop = Application.FixY(newTop, h);
		relLeft = adjustedLeft - newLeft;
		relTop = adjustedTop - newTop;
		oLeftTop[LEFT] = adjustedLeft;
		oLeftTop[TOP] = adjustedTop;
	} else {
		relLeft = 0;
		relTop = 0;
		oLeftTop[LEFT] = newLeft;
		oLeftTop[TOP] = newTop;
	}
	com.inq.flash.client.control.PersistenceManager.SetValues(oLeftTop);
	// true - it's flag for drag event.
	Application.ScrollStage(relLeft, relTop, true);
};


/**
 * getMinWidth
 *
 * $type TFun([],TInst(Int,[]))
 * public static function getMinWidth():Int
 * @public
 * @static
 * @return {number}
 */
Application.getMinWidth = function() {
	return Application.minWidth;
};


/**
 * getMinHeight
 *
 * $type TFun([],TInst(Int,[]))
 * public static function getMinHeight():Int
 * @public
 * @static
 * @return {number}
 */
Application.getMinHeight = function() {
	return Application.minHeight;
};


/**
 * ResizeStage
 *
 * $type TFun([{ name => newWidth, t => TDynamic(null), opt => false },{ name => newHeight, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function ResizeStage(newWidth:Dynamic, newHeight:Dynamic)
 * @public
 * @static
 * @param {null}  newWidth
 * @param {null}  newHeight
 * @return {void}
 */
Application.ResizeStage = function(newWidth,newHeight) {
	if(newWidth < Application.minWidth) newWidth = Application.minWidth;
	if(newHeight < Application.minHeight) newHeight = Application.minHeight;
	/** @type {Element} */
	var stgElement = com.inq.ui.Stage.getStageElement();
	if(stgElement && !Application.isPersistent) {
		stgElement.style.height = Application.application.stg.style.height = Std.string(newHeight) + "px";
		stgElement.style.width = Application.application.stg.style.width = Std.string(newWidth) + "px";

		/* Let's make sure that we reference the labels as
		 * strings, because we are referencing cookie values
		 * which cannot survive code obfuscation from here
		 */
		/** @type {Object} */
		var oHeightWidth = { };
		oHeightWidth[HEIGHT] = newHeight;
		oHeightWidth[WIDTH] = newWidth;
		if (!com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			com.inq.flash.client.control.PersistenceManager.SetValues(oHeightWidth);
		}
		Application.MoveSizeDiv2Stage(newWidth,newHeight);
	} else if (Application.isPersistent) {
		if(newWidth < Application.minWidth) newWidth = Application.minWidth;
		if(newHeight < Application.minHeight) newHeight = Application.minHeight;
		/** @type {number} */
		var deltaWidth = com.inq.ui.Stage.getterStageWidth() ? newWidth - com.inq.ui.Stage.getterStageWidth() : 0;
		/** @type {number} */
		var deltaHeight = com.inq.ui.Stage.getterStageHeight() ? newHeight - com.inq.ui.Stage.getterStageHeight() : 0;
		/** @type {Window} */
		var win = window.parent;
		if(deltaWidth != 0 || deltaHeight != 0) try {
			win.resizeBy(deltaWidth,deltaHeight);
		} catch( e ) {
		}
		Application.application.setWidth(Application.application.area.w = newWidth);
		Application.application.setHeight(Application.application.area.h = newHeight);
	}

	Application.Resize();
};


/**
 * Resize
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Resize():Void
 * @public
 * @static
 * @return {void}
 */
Application.Resize = function() {
	if(null != Application.application) Application.application.resize();
};


/**
 * doClick
 *
 * $type TFun([{ name => e, t => TType(js.Event,[]), opt => false }],TEnum(Bool,[]))
 * public static function doClick(e:Event):Bool
 * @public
 * @static
 * @param {js.Event}  e
 * @return {boolean}
 */
Application.doClick = function(e) {
	return false;
};


/**
 * _initTrace
 *
 * $type TFun([],TEnum(Bool,[]))
 * static private function _initTrace():Bool
 * @private
 * @static
 * @return {boolean}
 */
Application._initTrace = function() {
	haxe.Log.trace = com.inq.utils.ConsoleLogger.trace;
	return true;
};


/**
 * main
 * Definition and Usage - main() is the entry point of this application
 * Syntax: Application.main()
 *
 * $type TFun([],TEnum(Void,[]))
 * static function main()
 * @private
 * @static
 * @return {void}
 */
Application.main = function() {
	if(Application.hasRun) {
		Application.hasRun = false;
		Application._initTrace();
		Application.application = null;
	}
	Application.application = new Application();
	Application.application._init();
	Application._initTrace();

	/* The inqTitleBar div/image is so integrated into the code
	 * that it's easier just to leave it where it is, but not make
	 * it draggable.
	 */
	if(!com.inq.utils.Capabilities.isPhone()) {
		try {
			com.inq.stage.Move.setDragable();
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
		try {
			com.inq.stage.Resize.setResizable();
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
	}
};


/**
 * getInitialized - getter for the initialized flag
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function getInitialized():Bool
 * @public
 * @static
 * @return {boolean} - true/false
 */
Application.getInitialized = function() {
	if(Application.application != null) return Application.application.initialized;
	return false;
};

/** @private @type {boolean} */
Application.launchWhenReady = null;

/**
 * getter for LaunchWhenReady
 * --------------------- *
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function getLaunchWhenReady():Bool
 * @private
 * @static
 * @return {boolean}
 */
Application.getLaunchWhenReady = function() {
	return window[Application.lWR];
};


/**
 * setter for LaunchWhenReady
 * --------------------- *
 *
 * $type TFun([{ name => val, t => TEnum(Bool,[]), opt => false }],TEnum(Bool,[]))
 * private static function setLaunchWhenReady(val:Bool):Bool
 * @private
 * @static
 * @param {boolean}  val
 * @return {boolean}
 */
Application.setLaunchWhenReady = function(val) {
	window[Application.lWR] = val;
	return val;
};


/**
 * resizePersistentFrame
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function resizePersistentFrame():Void
 * @public
 * @static
 * @return {void}
 */
Application.resizePersistentFrame = function() {
	/** @type {Element} */
	var frm = window.frameElement;
	/** @type {number} */
	var xDelta;
	/** @type {number} */
	var yDelta;

	if(com.inq.utils.Capabilities.isMobile()) {
		/** @type {com.inq.utils.Area} */
		var vp = com.inq.utils.Capabilities.getViewport();
		Application.SetArea(vp);
	} else if(Application.resizable) {
		if(Application.popoutStageWidth == -1 && Application.popoutStageHeight == -1) Application.ResizeStage(Application.popoutStageWidth = frm.clientWidth,Application.popoutStageHeight = frm.clientHeight); else {
			/** @type {number} */
			var curWidth = frm.clientWidth;
			/** @type {number} */
			var curHeight = frm.clientHeight;
			if(curHeight == Application.popoutStageHeight && curWidth == Application.popoutStageWidth) return;

			if(curWidth < Application.minWidth) curWidth = Application.minWidth;
			if(curHeight < Application.minHeight) curHeight = Application.minHeight;
			xDelta = curWidth - frm.clientWidth;
			yDelta = curHeight - frm.clientHeight;
			if(xDelta != 0 || yDelta != 0) window.parent.resizeBy(xDelta,yDelta);
			Application.ResizeStage(Application.popoutStageWidth = curWidth,Application.popoutStageHeight = curHeight);
		}
	} else if(Application.popoutStageWidth == -1 && Application.popoutStageHeight == -1) Application.ResizeStage(Application.popoutStageWidth = frm.clientWidth,Application.popoutStageHeight = frm.clientHeight); else {
		xDelta = Application.popoutStageWidth - frm.clientWidth;
		yDelta = Application.popoutStageHeight - frm.clientHeight;
		window.parent.resizeBy(xDelta,yDelta);
	}
};


/**
 * Run
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Run()
 * @public
 * @static
 * @return {void}
 */
Application.Run = function() {
	if(Application.hasRun) return;
	Application.hasRun = true;
	var __px = com.inq.flash.client.chatskins.SkinControl.getPersistentXPos();
	var __py = com.inq.flash.client.chatskins.SkinControl.getPersistentYPos();
	var __pw = com.inq.flash.client.chatskins.SkinControl.getPersistentWidth();
	var __ph = com.inq.flash.client.chatskins.SkinControl.getPersistentHeight();
	com.inq.flash.client.control.FlashPeer.call("setPopoutChatPosAndDim",[__px,__py,__pw,__ph]);
	Application.application.run();
};


/**
 * keySet - get key set for all MXML containers
 *
 * public static function keySet():Array<String>
 * @public
 * @static
 * @return {Array} - string array of keys or an empty array
 */
Application.keySet = function() {
	/** @type {Array} */
	var keys = [];
	/** @type {Array} */
	var keyz = com.inq.utils.Util.fields(Application.application);
	for (var i = 0; i < keyz.length; i++) {
		/** @type {string} */
		var keyname = keyz[i];
		/** @type {*} */
		var item = Application.application[keyname];
		if (item != null) {
			try {
				if (js.Boot.__instanceof(item,com.inq.ui.Container)) {
					keys.push(keyname);
				}
			} catch( e ) {
				haxe.Log.trace("key value: " + keyname + " threw " + Std.string(e),{ fileName : "Application.hx", lineNumber : 1099, className : "Application", methodName : "keySet"});
			}
		} else haxe.Log.trace("key value: " + keyname + " returns null",{ fileName : "Application.hx", lineNumber : 1103, className : "Application", methodName : "keySet"});
	}
	return keys;
};


/**
 * getContainer - get container by name
 *
 * $type TFun([{ name => keyName, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.Container,[]))
 * public static function getContainer(keyName:String):Container
 * @public
 * @static
 * @param {string}  keyName - the id of the requested container
 * @return {com.inq.ui.Container} - container associated with the id, or null
 */
Application.getContainer = function(keyName) {
	/** @type {com.inq.ui.Container} */
	var container = Application.application[keyName];
	if(container == null) return container;
	if(js.Boot.__instanceof(container,com.inq.ui.Container)) return container;
	return null;
};


/**
 * customerEndsCobrowse
 *
 * $type TFun([],TEnum(Void,[]))
 * public function customerEndsCobrowse():Void
 * @public
 * @this Application
 * @return {void}
 */
Application.prototype.customerEndsCobrowse = function() {
	com.inq.flash.client.chatskins.SkinControl.endCobrowse();
};


/**
 * updateXFrameFromBizRule
 * Sets source of XFrame in CI if XFrame is visible, otherwise does nothing.
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => url, t => TInst(String,[]), opt => false },{ name => businessUnitID, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public function updateXFrameFromBizRule(layerID:String, url:String, ?businessUnitID:String):Void
 * @public
 * @this Application
 * @param {string}  layerID
 * @param {string}  url -  new source for layer
 * @param {string}  businessUnitID -  optional business unit id parameter
 * @return {void}
 */
Application.prototype.updateXFrameFromBizRule = function(layerID,url,businessUnitID) {
	/** @type {com.inq.flash.client.control.ApplicationController} */
	var thisApplicationController = this.applicationController;
	this.whenApplicationControllerInitialized(function() {
		if(com.inq.flash.client.control.XFrameWorker.isLayerVisible(layerID)) {
			com.inq.flash.client.control.XFrameWorker.showLayer(layerID,null,url,businessUnitID);
		}
	});
};

/**
 * Set source of XFrame and set visible
 */
Application.prototype.showAutomaton = function (layerId, url, businessUnitId, initiator) {
	/** @type {com.inq.flash.client.control.ApplicationController} */
	var thisApplicationController = this.applicationController;
	this.whenApplicationControllerInitialized(function () {
		com.inq.flash.client.control.XFrameWorker.showLayer(layerId, null, url, businessUnitId, null, initiator);
	});
};

/**
 * sendDTEvent
 * Send chat.automaton_response msg
 *
 * $type TFun([{ name => eventName, t => TInst(String,[]), opt => false },{ name => data, t => TMono(<mono>), opt => false }],TEnum(Void,[]))
 * public function sendDTEvent(eventName:String, data)
 * @public
 * @this Application
 * @param {string}  eventName -  event name
 * @param {TMono(<mono>)}  data -  parameters from chat.automaton_request msg
 * @return {void}
 */
Application.prototype.sendDTEvent = function(eventName,data) {
	if(this.applicationController != null) this.applicationController.sendDTEvent(eventName,data);
};


/**
 * This function set value of "visible" property of container with our application.
 *
 * @param {boolean} value for "visible" property.
 */
Application.prototype.setVisible = function(value) {
	com.inq.ui.Container.prototype.setVisible.call(this,value);
	com.inq.ui.Stage.getInstance().setVisible(value);
	this.setVisibleResizeCorner(value);
	this.titlebar.setVisible(value);
};

/**
 * This function defines current value of "visible" property of our application and returns it.
 *
 * @return {boolean} current visible state.
 */
Application.prototype.getVisible = function () {
	if (this._visible) {
		if (com.inq.ui.SkinLoader.skinInClient) {
			var chatWindow = com.inq.ui.Container.getElementById("chatWindow");
			var skin = com.inq.ui.Container.getElementById("Skin");
			if ((chatWindow && chatWindow.style.display === "none") || (skin && skin.style.display === "none")) {
				this.setVisible(false);
			}
		} else if (window.frameElement && window.frameElement.style.display === "none") {
			this.setVisible(false);
		}
	}
	return this._visible;
};


/**
 * whenApplicationControllerInitialized
 *
 * $type TFun([{ name => handler, t => TFun([],TEnum(Void,[])), opt => false }],TEnum(Void,[]))
 * public function whenApplicationControllerInitialized(handler : Void -> Void)
 * @public
 * @this Application
 * @param {TFun([],TEnum(Void,[]))}  handler
 * @return {void}
 */
Application.prototype.whenApplicationControllerInitialized = function(handler) {
	if(this.applicationController == null) this.onApplicationControllerInitializedHandlers.push(handler); else /*  push to the queue */
	handler();
};


/**
 * applyStyle
 * This is a subtask of Container apply style, we force the phone skin to fill up the entire window via style fixed
 * $type TFun([],TEnum(Void,[]))
 * override 	private function applyStyle():Void
 * @override
 * @private
 * @this Application
 * @return {void}
 */
Application.prototype.applyStyle = function () {
	com.inq.ui.Container.prototype.applyStyle.call(this);/* Call super class build style */
	if (com.inq.utils.Capabilities.isPhone()) {
		var bIsRelativePosition = com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid();
		this._div.style.position = bIsRelativePosition ? "relative" : "fixed";
		this._div.style.top = "0px";
		this._div.style.left = "0px";
		this._div.style.width = "";
		this._div.style.right = "0px";
		this._div.style.bottom = "0px";
		this._div.style.height = "";
		if (com.inq.utils.Capabilities.isWindowsPhone()) {
			this._div.style.position = bIsRelativePosition ? "relative" : "absolute";
			this._div.style.left = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() + "px";
			this._div.style.top = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() + "px";
			this._div.style.width = Application.application.area.w + "px";
			this._div.style.height = Application.application.area.h + "px";
		} else if (!com.inq.utils.Capabilities.isAndroid() && com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus()) {
			this._div.style.bottom = "";
			this._div.style.height = "" + Application.application.area.h + "px";
			if (com.inq.utils.Capabilities.isIphone()
				&& (com.inq.utils.Capabilities.isSafariVersion8()
					|| com.inq.utils.Capabilities.isSafariVersion9()
					|| com.inq.utils.Capabilities.isSafariVersion10()
					|| com.inq.utils.Capabilities.isSafariVersion11()
					|| com.inq.utils.Capabilities.isSafariVersion12()
					|| com.inq.utils.Capabilities.isSafariVersion13()
					|| com.inq.utils.Capabilities.isSafariVersion14orLater()
					|| com.inq.utils.Capabilities.isChromeiOS8()
					|| com.inq.utils.Capabilities.isChromeiOS10()
					|| com.inq.utils.Capabilities.isChromeiOS11()
					|| com.inq.utils.Capabilities.isSafariVersionPrior8()
					|| com.inq.utils.Capabilities.isIOSWebView())
			) {
				this._div.style.position = bIsRelativePosition ? "relative" : "absolute";
				this._div.style.top = window.parent.pageYOffset;
				this._div.style.left = Application.application.area.x + "px";
				if (com.inq.utils.Capabilities.isSafariVersion8()
					|| com.inq.utils.Capabilities.isSafariVersion9()
					|| com.inq.utils.Capabilities.isSafariVersion10()
					|| com.inq.utils.Capabilities.isSafariVersion11()
					|| com.inq.utils.Capabilities.isSafariVersion12()
					|| com.inq.utils.Capabilities.isSafariVersion13()
					|| com.inq.utils.Capabilities.isSafariVersion14orLater()
				) {
					this._div.style.right = "";
					this._div.style.width = "" + Application.application.area.w + "px"
				}
			}
		}
		/** This fixes incorrect bottom/right sizing. */
        else if (this._div.clientHeight < Application.application.area.h) {
			/** The fixed position did not work correctly, this happens on mobile,
			 * We know this because the client height was not equal to the computed height
			 * Sooooo ... we give it some help by fixing the height
			 */
			this._div.style.bottom = "";
			this._div.style.height = "" + Application.application.area.h + "px";
		} else if (
			com.inq.utils.Capabilities.isIphone()
			&& (com.inq.utils.Capabilities.isChromeiOS8()
			|| com.inq.utils.Capabilities.isChromeiOS10()
			|| com.inq.utils.Capabilities.isChromeiOS11()
			|| com.inq.utils.Capabilities.isSafariVersion8()
			|| com.inq.utils.Capabilities.isSafariVersion9()
			|| com.inq.utils.Capabilities.isSafariVersion10()
			|| com.inq.utils.Capabilities.isSafariVersion11()
			|| com.inq.utils.Capabilities.isSafariVersion12()
			|| com.inq.utils.Capabilities.isSafariVersion13()
			|| com.inq.utils.Capabilities.isSafariVersion14orLater())
		) {
			/* NOTICE: We want this code to only be for version 8 of Safari on the iPhone, only.  This is so we do not affect any other phones. */
			/** @type {Window} */
			var clientWin = window.top;
			if (clientWin.scrollY != 0 || clientWin.scrollX != 0) {
				/**
				 * @see http://jira.touchcommerce.com/browse/RTDEV-14784
				 * PROBLEM: User has to do a double touch on the input textarea to enable the keyboard (when address bar and bottom toolbar is hidden).
				 * FIX: Doing a scroll up action so that the address bar and bottom toolbar shows up in the iOS safari browser
				 *
				 * DESCRIPTION: Note that when you scroll down in iOS safari, the browser automatically hides the address bar and bottom toolbar. In this mode,
				 * if you touch any html element located at the bottom of the screen, then it brings back the address bar and bottom toolbar. This is the
				 * default behaviour of iOS Safari. Due to this behavior, in our chat window, the first touch on the input textarea, enables the address bar and
				 * the bottom toolbar only but does not bring up the soft keyboard. User has to touch again on the input textarea to enable the keyboard.
				 * To handle this behaviour, when we launch the chat, we makes sure the address bar and bottom toolbar is always visible and this is possible by
				 * programmatically doing a scroll up action.				 *
				 */
				clientWin.scrollTo(0, -1);
			}
			this._div.style.bottom = "";
			this._div.style.height = "" + Application.application.area.h + "px";
			this._div.style.right = "";
			this._div.style.width = "" + Application.application.area.w + "px";
			this._div.style.position = bIsRelativePosition ? "relative" : "absolute";
			this._div.style.top = window.parent.pageYOffset;
			this._div.style.left = 0 + "px";

		} else if (com.inq.utils.Capabilities.isAndroid() && com.inq.utils.Capabilities.getChromeVersion() >= 40) { // returns -1 if we're not on Chrome.
			this._div.style.bottom = "";
			this._div.style.right = "";
			this._div.style.height = "" + Application.application.area.h + "px";
			this._div.style.width = "" + Application.application.area.w + "px";
		} else {
			haxe.Log.trace("WARNING: Applying NO width & height to Application!", {
				fileName: "Application.js",
				lineNumber: 1033,
				className: "Application",
				methodName: "applyStyle"
			});
        }
        }
};

/**
 * run
 *
 * $type TFun([],TEnum(Void,[]))
 * public function run()
 * @public
 * @this Application
 * @return {void}
 */
Application.prototype.run = function() {
	Application.setLaunchWhenReady(true);
	Application.minWidth = com.inq.utils.Util.getConfig("minWidth",250);
	Application.minHeight = com.inq.utils.Util.getConfig("minHeight",150);
	Application.resizable = com.inq.utils.Util.getConfig("resizable",true);
    Application.draggable = com.inq.utils.Util.getConfig("draggable",true);
	/**
	 * RTDEV-15839 - read and assign the setFocusOnClose property for re-use later in the code.
	 */
	Application.setFocusToBtnCloseOnOpen = com.inq.utils.Util.getConfig("setFocusOnClose",false);

	/** @type {string} */
	var tooltipResize = com.inq.utils.Util.getConfig("tooltipResize","");
	/** @type {string} */
	var tooltipDrag = com.inq.utils.Util.getConfig("tooltipDrag","");

	if (com.inq.utils.Capabilities.isIphone()) {
		/**
		 * RTDEV-16228 - read the <parentDocumentBodyMarginTop> property from skin file. If defined,
		 * get the top value of the client bounding rectangle that will be used in <applyStyle> function to set the
		 * top value for <tcChat_Skin>.  Without this, part of the chat skin will be hidden.
		 */
		if (com.inq.utils.Util.getConfig("parentDocumentBodyMarginTop", false)) {
			Application.parentDocumentBodyMarginTop = window.parent.document.body.getBoundingClientRect().top;
		}
	}

	/* TODO: Must develop centralized module to query chat configuration under Application
		Suggest to use Application.chatConfig.
			Capabilities class contains many util functions which should belong to Util
		- DL -
	*/
	var isPersistent = com.inq.flash.client.control.FlashPeer.isPersistentWindow();
	var isDivChat = com.inq.utils.Util.getConfig("divSkin", false);
	if((com.inq.utils.Capabilities.isMobile() || isDivChat) && !isPersistent) {
		isDivChat = true;
	}

	/* Chat Language
	   chat skin configuration variable; overwriteLang or inheritDefaultLang
	   1. If overwriteLang is set, use it to set tcChat_Skin, tcChat_Minimized, and btnThankYou
	   2. Else if skin config inheritDefaultLang is found,
	      Use Parent's lang attribute, or if parent has no lang attribute, use inheritDefaultLang value
	*/
	var overwriteLang = com.inq.utils.Util.getConfig("overwriteLang",null);
	var inheritDefaultLang = com.inq.utils.Util.getConfig("inheritDefaultLang",null);
	setLangAttribute("Skin");
	setLangAttribute("Minimized");
	setLangAttribute("btnThankYou");

	/* The html lang setting will be inherited from the client page,
	 * However, if the config JSON defines the setting (as "ariaLanguage") then it will overide.
	 * The default is english "en"
	 * Fix - html in client page gets lang attribute.
	 */
	/* deprecated - ariaLang; replace it with overwriteLang */
	var clientLang = window.parent.document.body.parentNode.lang;
	clientLang = com.inq.utils.Util.getConfig("ariaLang",(clientLang)?clientLang:"en");
	if(isPersistent) {  // On Persistent Chat, add lang attribute to out most HTML element.
		window.parent.document.body.parentNode.lang = (overwriteLang != null ? overwriteLang : clientLang);
	} else if (!isDivChat) { // Non Persistent Chat, if chat is in iFrame, add lang attribute to iframe's HTML element.
		window.document.body.parentNode.lang = (overwriteLang != null ? overwriteLang : clientLang);
	}

	// resizecorner module
	if (this.resizeCorner && this.resizeCorner._div) {
		this.resizeCorner._div.getElementsByTagName("INPUT")[0].title = tooltipResize;
	}
    var titlebarDivs = this.titlebar._div.getElementsByTagName("INPUT");
    if (titlebarDivs.length > 0)  {
        this.titlebar._div.getElementsByTagName("INPUT")[0].title = tooltipDrag;
    }

	if(!com.inq.utils.Capabilities.isPhone()) {
		try {
			com.inq.stage.Move.setDragable();
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
		try {
			com.inq.stage.Resize.setResizable();
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
	}

	Application.application.setInitialSize();
	var /** @type {boolean} */ isNewApplicationControllerCreated = null == this.applicationController;
	if(isNewApplicationControllerCreated) {
		this.applicationController = new com.inq.flash.client.control.ApplicationController();
		this.applicationController.registerMessageHandlers();
	}
	com.inq.flash.client.chatskins.SkinControl.setApplicationController(this.applicationController);
	com.inq.flash.client.chatskins.SkinControl.bInitialized = false;
	try {
		com.inq.flash.client.chatskins.SkinControl.InitializeGlue();
	} catch( e ) {

		haxe.Log.trace("ERROR: In InitializeGlue: " + Std.string(e),{ fileName : "Application.hx", lineNumber : 999, className : "Application", methodName : "run"});
	}
	//For async chat we will initialize automaton on callback of transcript request
	if (!this.applicationController.getChat().isAsyncChat()) {
		this.applicationController.initializeAutomatonMode();
	}
	this.applicationController.checkIfAdBlockersActive();

	if(isNewApplicationControllerCreated) {
		/*  call event handlers */
		var /** @type {number} */ _g = 0, /** @type {Array} */ _g1 = this.onApplicationControllerInitializedHandlers;
		while(_g < _g1.length) {
			var /** @type {?} */ handler = _g1[_g];
			++_g;
			handler();
		}
	}

	com.inq.aria.AriaMsg.onChatShown();

    Application.application.setupWindowIdHandler();

	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		this.setVisible(true);
		this.resize();
	}

	/**
	 * setLangAttribute
	 *
	 * Private static function call to set lang attribute on the given object.
	 *
 	 * @param {string} objId - id of a div element
	 */
	function setLangAttribute (objId) {
		var obj;
		try {
			obj = com.inq.ui.Container.getElementById(objId);
			if (objId.indexOf(com.inq.ui.Container.CLIENT_SPACE_PREFIX) != 0 && obj == null) {
				obj = com.inq.ui.Container.getElementById(com.inq.ui.Container.CLIENT_SPACE_PREFIX + objId);
			}
			if (obj != null) {
				if (overwriteLang != null) {
					obj.setAttribute("lang", overwriteLang);
				}
				else if (inheritDefaultLang != null) {
					obj.setAttribute("lang", (clientLang) ? clientLang : inheritDefaultLang);
				}
			}
		} catch(e) { /* DOM operation; ignore Any issue and move on */ }
	} /* End of setLangAttribute() */
};

/**
 * setupWindowIdHandler
 *
 * public function setupWindowIdHandler():Void
 * RTDEV-23774: For chats that support multiple chat windows, add event listeners that will
 * add the current window id to the active list of window ids on the server and make it
 * the master id.
 * The event handlers are required for both focus and visibilitychange events, so that it
 * is more reliable. Even if both are triggered, it is still ok.
 * @return {void}
 */
Application.prototype.setupWindowIdHandler = function () {
    //Only for chats that support multiple window chats
    if (com.inq.flash.client.control.FlashPeer.isMultiChatSupported()) {
        //set up listeners for both visibilitychange and focus.
        top.window.addEventListener("focus", Application.application.setActiveWindowId);
        top.window.document.addEventListener("visibilitychange", Application.application.setActiveWindowId);
    }
};

/**
 * setActiveWindowId
 *
 * public function setActiveWindowId():Void
 * RTDEV-23774: For chats that support multiple chat windows, add event listeners that will
 * add the current window id to the active list of window ids on the server and make it
 * the master id.
 * @return {void}
 */
Application.prototype.setActiveWindowId = function () {
    //set it only if visible - this can also happen when you right click on a link and
    // do a "open in new tab" and when the chat is connected
    if (!window.top.document.hidden && Application.application.isConnected()) {
        com.inq.flash.client.control.FlashPeer.setActiveWindowId();
    }
};

/**
 * setInitialSize
 *
 * $type TFun([],TEnum(Void,[]))
 * public function setInitialSize():Void
 * @public
 * @this Application
 * @return {void}
 */
Application.prototype.setInitialSize = function() {
	/** @type {number} */
	var __height;
	/** @type {number} */
	var __width;
	/** @type {Window} */
	var __winParent = window.parent;
	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	var embeddedTheme = com.inq.flash.client.control.FlashPeer.getEmbeddedTheme();
	if (embeddedTheme && embeddedTheme.isValid) {
		__width = embeddedTheme.w;
		__height = embeddedTheme.h;
	} else if (com.inq.utils.Capabilities.isPhone()) {
		com.inq.stage.ViewportMgr.impl.saveScrollPosition();
		com.inq.flash.client.chatskins.ScrollMonitor.ScrollToNearTop();
		__width = vp.w;
		__height = vp.h;
	} else {
		__width = com.inq.flash.client.chatskins.SkinControl.getSkinWidth();
		__height = com.inq.flash.client.chatskins.SkinControl.getSkinHeight() + com.inq.flash.client.chatskins.SkinControl.getTitleBarHeight();

		/*
		 @see: RTDEV-10204: Fix for android devices to align chat window
		 */
		__width = com.inq.flash.client.control.PersistenceManager.GetValue(WIDTH, __width);
		__height = com.inq.flash.client.control.PersistenceManager.GetValue(HEIGHT, __height);
	}

	/** @type {Element} */
	var iframe = js.Lib.window.frameElement;
	if(com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		/**
		 * if persistent chat
		 * then:
		 * 	1) stage and iframe must be 100% width and height so it can resize with window
		 *	2) no corner or resizing title bar
		 * 	3) control resizing via the "onresize" event
		 * 		a) for IE from the IFRAME
		 * 		b) else from the window
		 */
		Application.isPersistent = true;
		this.stg.style.height = "100%";
		this.stg.style.width = "100%";
		this.stg.style.left = "0px";
		this.stg.style.top = "0px";
		/* the iframe must be 100% by 100% to resize with window */
		iframe.style.width = "100%";
		iframe.style.height = "100%";
		this.titlebar.setVisible(false);
		this.setVisibleResizeCorner(false);
		this.styles.width = this.stg.clientWidth;
		this.styles.height = this.stg.clientHeight;
		/* make sure that the persistent window has no scroll bar */
		window.parent.document.body.style.cssText += ";overflow: hidden;overflow-Y:hidden;overflow-X:hidden;margin:0px;padding:0px";

		/** @type {Element} */
		var el = window.document.all ? window.frameElement : window.parent;
		iframe._resizeTimer = -1;

		/**
		 * Called when there is a resize of persistent chat window.
		 * @name resizeHandler
		 * @event resize
		 */
		var resizeHandler = function() {
			/** @type {HTMLElement} */ var frm = window.frameElement;
			/** @type {number} */ var newWidth = frm.clientWidth;
			/** @type {number} */ var newHeight = frm.clientHeight;

			if(newWidth != frm._oldWidth || newHeight != frm._oldHeight) {
				if(frm._resizeTimer != -1) window.clearTimeout(frm._resizeTimer);
				frm._oldWidth = newWidth;
				frm._oldHeight = newHeight;
				frm._resizeTimer = window.setTimeout(function() {
					Application.resizePersistentFrame();
				},50);
			}
		};

		com.inq.utils.Capabilities.BindListener(el,"resize",resizeHandler);

		iframe._oldWidth = iframe.clientWidth;
		iframe._oldHeight = iframe.clientHeight;
		/* http://dev.inq.com/jira/browse/REQ-2505
		 * Call the resize as if we just got a resize event
		 * This is incase the newly created chat missed the initial resize event
		 * ... as happens in Chrome
		 */
		iframe._resizeTimer = window.setTimeout(function() {
			Application.resizePersistentFrame();
		},50);
		Application.ResizeStage(window.top.document.body.clientWidth, window.top.document.body.clientHeight);

		this.resize();
		return;
	} else {
		this.stg.style.height = __height + "px";
		this.stg.style.width = __width + "px";
		/** @type {number} */
		var mbHeight = com.inq.flash.client.chatskins.SkinControl.getTitleBarHeight();
		/** @type {com.inq.utils.Point} */
		var position = Application.calcChatLocation(
			com.inq.flash.client.chatskins.SkinControl.getSkinWidth(),
			com.inq.flash.client.chatskins.SkinControl.getSkinHeight() + mbHeight,
			com.inq.flash.client.chatskins.SkinControl.getSkinLeft(),
			com.inq.flash.client.chatskins.SkinControl.getSkinTop(),
			com.inq.flash.client.chatskins.SkinControl.getSkinLocation()
		);
		position.x = com.inq.flash.client.control.PersistenceManager.GetValue(LEFT, position.x);
		position.y = com.inq.flash.client.control.PersistenceManager.GetValue(TOP, position.y);
		if ((__height < vp.h && __width < vp.w) || com.inq.utils.Capabilities.isPhone()) {
			this.area.x = position.x = Application.FixAbsoluteX(position.x, __width);
			this.area.y = position.y = Application.FixAbsoluteY(position.y, __height);
		}
		this.stg.style.left = position.x + "px";
		this.stg.style.top = position.y + "px";
		if(iframe) {
			iframe.style.width = this.stg.style.width;
			iframe.style.height = this.stg.style.height;
		}
	    /*
 This method checks that height/width against min values
 It repositions the titlebar and the resize corner accordingly
 It sets the area properties of the application
 It DOES NOT  resize the stage or the skin div ( aka application )
 */
		Application.MoveSizeDiv2Stage(__width,__height,position.x,position.y);
		/** @static
		 * @public
		 * @type {number}
		 */
		Application.initialXPos = position.x - vp.x;
		/** @static
		 * @public
		 * @type {number}
		 */
		Application.initialYPos = position.y - vp.y;
	}
	/*
	   therefor at this point stg.style.height - has NOT been updated
	   and should not be used or it will be inconsistent with possible changes made to title bar and resize corer
	 instead Application.application.area should be used because that is what just got updated in MoveSizeDiv2Stage */
	__height = Application.application.area.h;
	__width = Application.application.area.w;
	/* meanwhile stage still needs to be resized, none of the calls move size div etc does that except for
	the incredibly well named ResizeStage !! so call it */
	this.styles.height = "" + __height;
	this.styles.width = "" + __width;

	if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid() && com.inq.utils.Capabilities.isSafari()) {
		window.setTimeout(function () {
			Application.ResizeStage(__width, __height);
		}, 500);
	} else {
		Application.ResizeStage(__width, __height);
	}
	// dont bother calling resize now, call it after class inits ( inside SkinControl.InitializeGlue method )
	// because other elements arent ready yet

};


/**
 * Calculates chat location depending on 'location' parameter. If 'W' or 'H' parameters are
 * less then minimal values defined in {@link Application.minHeight} and {@link Application.minWidth},
 * then minimal values will be used. Parameters X and Y will be used if 'location' parameter equals to
 * 'ABSOLUTE' or 'RELATIVE'.
 *
 * @public
 * @param W width of the chat skin
 * @param H height of the chat skin
 * @param X the horizontal position of left-top corner of the chat window.
 * @param Y the vertical position of left-top corner of the chat window
 * @param location the position specifier for where to position the client skin.
 *	Possible values are:
 *	"UPPER_CENTER", "TOP_CENTER"
 *	"UPPER_RIGHT", "TOP_RIGHT"
 *	"UPPER_LEFT", "TOP_LEFT"
 *	"CENTER_LEFT"
 *	"CENTER_RIGHT"
 *	"LOWER_LEFT", "BOTTOM_LEFT"
 *	"LOWER_CENTER", "BOTTOM_CENTER"
 *	"LOWER_RIGHT", "BOTTOM_RIGHT"
 *	"POP_UNDER_CENTER"
 *	"ABSOLUTE"
 *	"RELATIVE"
 *	"CENTER"
 * @return {com.inq.utils.Point}
 */
Application.calcChatLocation = function(W, H, X, Y, location) {
	/** @type {number} */
	var left = 0;
	/** @type {number} */
	var top = 0;
	/** @type {number} */
	var scrollBarWidth = com.inq.utils.Util.isIE ? 0 : com.inq.flash.client.chatskins.ScrollMonitor.getScrollBarWidth();
	/** @type {boolean} */
	var isRightScrollBar = Application.hasRightScrollBar();
	/** @type {boolean} */
	var isBottomScrollBar = Application.hasBottomScrollBar();

	/** @type {number} */
	var inq_scroll_width;
	/** @type {number} */
	var inq_scroll_height;

	if (com.inq.utils.Util.isIE) {
		inq_scroll_height = window.parent.document.documentElement.clientHeight;
		if (inq_scroll_height == 0) {
			inq_scroll_height = window.parent.document.body.clientHeight;
		}
		inq_scroll_width = window.parent.document.documentElement.clientWidth;
		if (inq_scroll_width == 0) {
			inq_scroll_width = window.parent.document.body.clientWidth;
		}
	} else {
		inq_scroll_height = window.parent.innerHeight;
		inq_scroll_width = window.parent.innerWidth;
	}

	if (W < Application.minWidth) {
		W = Application.minWidth;
	}

	if (H < Application.minHeight) {
		H = Application.minHeight;
	}

	switch (location.toUpperCase()) {
		case "UPPER CENTER":case "UPPER_CENTER":case "TOP_CENTER":
			top = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			left = inq_scroll_width / 2 - W / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			break;
		case "UPPER_RIGHT":case "TOP_RIGHT":
			top = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			left = inq_scroll_width - W + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() - (isRightScrollBar ? scrollBarWidth : 0);
			break;
		case "UPPER_LEFT":case "TOP_LEFT":
			top = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			left = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			break;
		case "CENTER_LEFT":
			top = inq_scroll_height / 2 - H / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			left = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			break;
		case "CENTER_RIGHT":
			top = inq_scroll_height / 2 - H / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			left = inq_scroll_width - W + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() - (isRightScrollBar ? scrollBarWidth : 0);
			break;
		case "LOWER_LEFT":case "BOTTOM_LEFT":
			top = inq_scroll_height - H + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() - (isBottomScrollBar ? scrollBarWidth : 0);
			left = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			break;
		case "LOWER_CENTER":case "BOTTOM_CENTER":
			top = inq_scroll_height - H + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() - (isBottomScrollBar ? scrollBarWidth : 0);
			left = inq_scroll_width / 2 - W / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			break;
		case "LOWER_RIGHT":case "BOTTOM_RIGHT":
			left = inq_scroll_width - W + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() - (isRightScrollBar ? scrollBarWidth : 0);
			top = inq_scroll_height - H + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() - (isBottomScrollBar ? scrollBarWidth : 0);
			break;
		case "POP_UNDER_CENTER":
			left = inq_scroll_width / 2 - W / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			top = inq_scroll_height / 2 - H + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			break;
		case "ABSOLUTE":
			left = X;
			top = Y;
			break;
		case "RELATIVE":
			left = X + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			top = Y + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			break;
		case "CENTER":
			left = inq_scroll_width / 2 - W / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
			top = inq_scroll_height / 2 - H / 2 + com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
			break;
	}

	if(left == null || left < 0) left = 100;

	if(null == top || top < 0) top = 100;
	/* return {top: top, left: left } ; */
	return new com.inq.utils.Point(left | 0,top | 0);
};

/**
 * Determines whether a vertical scroll bar appears on the screen.
 * @returns {boolean}
 */
Application.hasRightScrollBar = function() {
	var clientHeight = window.parent.document.documentElement.clientHeight;
	var clientWidth =  window.parent.document.documentElement.clientWidth;
	var scrollHeight = window.parent.document.documentElement.scrollHeight;
	var innerWidth = window.parent.innerWidth;

	return (clientHeight < scrollHeight)  // This means we need to scroll.
		   || (clientWidth < innerWidth); // Indicates that a grayed-out scroll bar already appears.
};

/**
 * Determines whether a horizontal scroll bar appears on the screen.
 * @returns {boolean}
 */
Application.hasBottomScrollBar = function() {
	var clientWidth = window.parent.document.documentElement.clientWidth;
	var scrollWidth = window.parent.document.documentElement.scrollWidth;
	var clientHeight = window.parent.document.documentElement.clientHeight;
	var innerHeight = window.parent.innerHeight;
	return (clientWidth < scrollWidth)      // This means we need to scroll
		   || (clientHeight < innerHeight); // Indicates that a grayed-out scroll bar already appears.
};

/**
 * Parsing last conversation transcript data and insert into chat transcript
 * If error occurred show openers like for simple chat
 * @param {Object|String} response transcript data in JSON or stringified JSON format
 * @param {Function} callback function {@link com.inq.flash.client.chatskins.SkinControl.showOpenerScripts} to show openers if error was thrown or no messages returned
 * @return {boolean} true if no errors were thrown during parsing otherwise false
 */
Application.processConversationTranscriptResponse = function(response, callback) {
	var processResult = false;
	try {
		//true if any messages were inserted into transcript
		com.inq.flash.client.chatskins.SkinControl.parseConversationTranscript(response);
		processResult = true;
	} catch(e) {
		haxe.Log.trace("SkinControl.processConversationTranscriptResponse " + Std.string(e), { fileName: "Application.js", lineNumber: 1688, className: "Application", methodName: "processConversationTranscriptResponse", customParams: ["error"]});
	}
	callback();
	return processResult;
};

/**
 * getParentBody
 * Parent body getter
 *
 * @this Application
 * @return {HTMLElement}
 */
Application.prototype.getParentBody = function () {
	if (com.inq.utils.Util.getConfig("divSkin", false) || com.inq.ui.SkinLoader.skinInClient) {
		return top.window.document.body;
	} else {
		return this.stg.contentWindow.document.body;
	}
};

/**
 * _run
 * Runs the application after loading of the skin.
 *
 * @private
 * @this Application
 * @param {object} e - event object
 * @return {void}
 */
Application.prototype._run = function(e) {
	/**
	 * loader - element in inqChatLaunch, shows "Loading..." message while native post chat survey is loading.
	 * We have to hide it after that.
	 * @type {HTMLElement | null}
	 */
	var loader = window.document.getElementById(com.inq.ui.SkinLoader.LOADER_CONTAINER_ID) || com.inq.ui.Container._getElementById(com.inq.ui.SkinLoader.LOADER_CONTAINER_ID,window.parent.document);
	if (loader !== null) {
		loader.style += "display: none;"
	}
	com.inq.utils.Capabilities.BindListener(this.getParentBody(), "keydown", Application.keydownHandler);

	// Set title in the persistent chat window.
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		window.parent.document.title = com.inq.utils.Util.getConfig("sPersistentFrameTitle", "Chat");
	}

	this.applyStyle();
	this.notificationController = new com.inq.flash.client.control.NotificationController(this);

	if (Application.getLaunchWhenReady()) {
		Application.Run();
	}

	this.dispatchEvent(e);
};

/**
 * _init
 *
 * private function _init()
 * @private
 * @this {Application}
 * @return {void}
 */
Application.prototype._init = function() {
	/** @type {string} */
	var skin = com.inq.flash.client.control.FlashPeer.getSkin(); // default value

	/* In Haxe 2.10 we are producing complient javascript that is
	 * strict and self contained.
	 * So we must "publish" our entry points so that the IJSF can access them
	 */
	com.inq.utils.Util.publish("com",window.com);
	com.inq.utils.Util.publish("Application",Application);
	com.inq.utils.Util.publish("Application.application",this);
	com.inq.utils.Util.publish("Application.application.setVisible",$bind(this,this.setVisible));
	com.inq.utils.Util.publish("Application.application.close",$bind(this,this.close));
	com.inq.utils.Util.publish("Application.application.updateStyle",$bind(this,this.updateStyle));
	com.inq.utils.Util.publish("Application.application.restartTimer", $bind(this, this.restartTimer));
	com.inq.utils.Util.publish("Application.getInitialized",Application.getInitialized);
	com.inq.utils.Util.publish("Application.Run",Application.Run);
	com.inq.utils.Util.publish("Application.application.sendDTEvent",$bind(this,this.sendDTEvent));
	com.inq.utils.Util.publish("Application.sendVALinkClicked", Application.sendVALinkClicked);
	com.inq.utils.Util.publish("Application.agentQuickResponse", Application.agentQuickResponse);
	com.inq.utils.Util.publish("Application.processConversationTranscriptResponse", Application.processConversationTranscriptResponse);
	com.inq.utils.Util.publish("Application.expandChat", Application.expandChat);
	com.inq.utils.Util.publish("Application.shrinkChat", Application.shrinkChat);
	com.inq.utils.Util.publish("Application.application.isConnected", $bind(this, this.isConnected));
	com.inq.ui.Stage.getInstance().setVisible(false);

	this._reInit(); // reinitialize variables.

	if(com.inq.flash.client.control.FlashPeer.noV3FrameChat()){
		this.stg = document.getElementById("inqChatStage");
		if(!this.stg) {
			this.stg = document.createElement("iframe");
			this.stg.setAttribute("id", "inqChatStage");
			this.stg.setAttribute("style", "z-index:999999;position:absolute;");
			document.body.appendChild(this.stg);
		}
	} else if(js.Lib.window.frameElement) {
		/** @type {HTMLDocument} */
		var pDoc = window.frameElement.ownerDocument;
		this.stg = com.inq.ui.Container._getElementById("inqChatStage",pDoc);
	}

	this.skinLoader.addEventListener(com.inq.events.Event.COMPLETE,$bind(this,this._run));
	this.addEventListener(com.inq.events.Event.COMPLETE, com.inq.flash.client.control.FlashPeer.onChatLoaded);
	this.addEventListener(com.inq.events.Event.COMPLETE, com.inq.flash.client.control.FlashPeer.onChatShown);

	if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
		this.skinLoader.drawSkinLocal();
	} else {
		if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			skin = com.inq.flash.client.control.PersistenceManager.GetValue(EMBEDDED_SKIN_PATH, skin);
		} else {
			skin = com.inq.flash.client.control.PersistenceManager.GetValue(SKIN_PATH, skin);
		}
		this.skinLoader.drawSkin(skin);
	}

	this.initialized = true;
};

/**
 * ReInitialize variables when App starts twice or more without page reload.
 * @private
 * @this Application
 * @return {void}
 */
Application.prototype._reInit = function() {
	com.inq.flash.client.control.PersistenceManager.reopen(); // order is important for PersistenceManager.reopen() and SkinControl.init()
	com.inq.flash.client.chatskins.SkinControl.init(); // Need to be reInit in this method otherwise it initializes on each page reload.
	com.inq.addons.Salesforce.reset();
};

/**
 * agentQuickResponse
 *
 * processes click on properly configured live agent links
 *
 * @public
 * @static
 * @param {Event} event - click on link event
 */
Application.agentQuickResponse = function (event) {

	var app = Application.application;
	var eventTarget = event.target;
	var responseText = eventTarget.getAttribute('data-nuance-quick-answer');

	if (app != null && app.applicationController != null) {
		if (responseText) {
			app.applicationController.agentQuickResponse(event);
		}
	}
};


/**
 * sendVALinkClicked
 * Processing clicks on virtual agent dialog links
 * @public
 * @static
 * @return {void}
 */

Application.sendVALinkClicked = function(event) {
	var app = Application.application;
	if (app != null && app.applicationController != null) {
		app.applicationController.sendVALinkClicked(event);
	}
};

/**
 * Sets survey config and fires event to load native post chat survey
 *
 * @param {MouseEvent|TouchEvent} event
 */
Application.launchPostChatSurvey = function(event) {
	/** @type {Application} */
	var app = Application.application;
	if (app && app.applicationController) {
		app.applicationController.launchPostChatSurvey(event);
	}
};

/**
 * getImagePath
 *
 * $type TFun([],TInst(String,[]))
 * private function getImagePath()
 * @private
 * @this Application
 * @return {string}
 */
Application.prototype.getImagePath = function() {
    if (com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
        var imagePath = com.inq.flash.client.control.FlashPeer.getMediaPath();
        return imagePath
    }
    else {
        if (this.imgpath) {
            return this.imgpath
        }
        var skinFolderName = com.inq.flash.client.control.FlashPeer.getSkin().split("/").pop().split(".").shift();
        return this.imgpath = com.inq.flash.client.control.FlashPeer.getImagePath() + skinFolderName + "/"
    }
};


/**
 * resize
 *
 * public override function resize()
 * @override
 * @public
 * @this Application
 * @return {void}
 */
Application.prototype.resize = function() {
	com.inq.ui.Container.prototype.resize.call(this);/*  resize this application*/
	this.resizer(Application.containsOutside);/*  resize the corner and titlebar drag*/
	this.resizer(this.contains);/*  resize all children and children...children*/
	com.inq.flash.client.chatskins.BalloonNotifier.Resize();
};

/**
 * expandChat - is used to resize the chat interface and display the chat in full screen mode.
 * The current implementation is supported for iPhone only.
 */
Application.expandChat = function() {
	return com.inq.flash.client.chatskins.ChatTextFocusMonitor.expandChat();
};

/**
 * shrinkChat - is used to resize the chat interface when keyboard is displayed.
 * The current implementation is supported for iPhone only.
 */
Application.shrinkChat = function() {
	return com.inq.flash.client.chatskins.ChatTextFocusMonitor.shrinkChat();
};

/**
 * initializeParameters
 *
 * $type TFun([],TEnum(Void,[]))
 * private function initializeParameters()
 * @private
 * @this Application
 * @return {void}
 */
Application.prototype.initializeParameters = function() {
	this.parameters = new com.inq.utils.Dictionary();
	/** @type {string} */
	var flashvarsString = "";
	try {
		flashvarsString = com.inq.flash.client.control.FlashPeer.getFlashVars();

		flashvarsString = flashvarsString.split("socket,").join("");
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERRORS:" + Std.string(e),{ fileName : "Application.hx", lineNumber : 240, className : "Application", methodName : "initializeParameters"});
		} else throw(e);
	}
	/** @type {Array} */
	var flashVars = flashvarsString.split("&");
	for (var i = 0; i < flashVars.length; ++i) {
		/** @type {Array} */
		var keyValuePair = ("" + flashVars[i]).split("=");
		this.parameters[keyValuePair[0]] = keyValuePair.length == 1 ? null : decodeURIComponent(keyValuePair[1]);
	}

	com.inq.flash.client.control.FlashVars._init();
};


/**
 * close
 *
 * $type TFun([],TEnum(Void,[]))
 * public function close():Void
 * @public
 * @this Application
 * @return {void}
 */
Application.prototype.close = function() {
	window.onunload = function(ev) {
		return true;/* Remove window unload functionality */
	};/* Remove window unload functionality */
	com.inq.flash.client.chatskins.SndMgr.setMute(false);/*  Set this to the default when we close.  on Init mobile rules take over*/
	this.applicationController.disable();

	// Important - need to reset customer page body position or we break it.
    if (com.inq.utils.Capabilities.isAndroid() && Application.savePage && Application.savePage.bodyPosition !== null) {
        top.window.document.body.style.position = Application.savePage.bodyPosition;
        Application.savePage.bodyPosition = null;
    }

	/** @type {Element} */
	var div = this._div;
	if(div != null) {
		/** @type {Node} */
		var parentnode = div.parentNode;
		if(parentnode != null) {
			try {
				parentnode.removeChild(div);
			} catch( e ) {
				if( js.Boot.__instanceof(e,Error) ) {
					haxe.Log.trace("ERROR REMOVING DIV:" + Std.string(e),{ fileName : "Application.hx", lineNumber : 206, className : "Application", methodName : "close"});
				} else throw(e);
			}

		}
		this._div = null;
		com.inq.ui.Stage.stage.cleanUp();
		com.inq.ui.Stage.stage = null;
		this.stage = null;
		this.screen = null;
		this.skinLoader.cleanUp();
		this.cleanUp();
		com.inq.flash.client.chatskins.SkinControl.cleanUp();
		com.inq.flash.client.control.ApplicationController.cleanUp();
	}

	/** @type {Element} */
	var pDoc = window.parent.document;
	var inqTitleBar = com.inq.ui.Container._getElementById("inqTitleBar",pDoc);
	/** @type {Element} */
	var inqFrame = com.inq.ui.Container._getElementById("inqChatStage",pDoc);

	if(inqFrame != null) inqFrame.style.display = "none";
	this.setVisibleResizeCorner(false);
	if(inqTitleBar != null) inqTitleBar.style.display = "none";
	/**
	 * @see http://jira.touchcommerce.com/browse/RTDEV-10725
	 * @description this is to make sure that viewport is closed as the last item.
	 */
	com.inq.stage.ViewportMgr.close();
};

/**
 * Disables the communication options of the chat application.
 *
 * @param {boolean=} showNotification - this optional flag means that chat was removed from the server,
 *                  this is possible only when chat is ended by incorrect way,
 *                  e.g. when customer lost the connection
 * @returns {void}
 */
Application.prototype.disable = function(showNotification) {
	if (this.applicationController && this.applicationController.isConnected()) {
		this.applicationController.disable();
		if (showNotification || this.applicationController.isSendMessageFail()) {
			this.notificationController.showConnectionFailedMessage();
		}
	}
};

/**
 * Update element style attributes with provided values
 * @public
 * @this Application
 * @param elementId The id refers to a layer defined in the mxml of the CI theme that is currently active.
 * @param attributes The object that contains a list of key-value pairs. The keys will refer to dimensions referenced in the mxml.
 * value could be null, number or string expression.
 * @return {void}
 */
Application.prototype.updateStyle = function(elementId, attributes) {
	/** @type {Element} */
	var element;
	if (elementId == "Skin") {
		element = this;
	} else {
		element = this.getMxmlItem(elementId);
	}
	if (element && (element.getID() == "Skin" || element instanceof com.inq.ui.Container)) {
		for (var attr in attributes) {
			var value = attributes[attr];

			if (value == null || typeof(value) == "undefined") {
				break;
			}

			if (!isNaN(Number(value))) {
				element.styles[attr] = String(value);
			} else if (typeof value == "string") {
				var parsedValue = this.parseStyleExpression(attr, value.trim());
				element.styles[attr] = parsedValue;
			} else {
				throw new Error("Unknown attribute('"+ attr + "') value type");
			}
		}
		this.resize();
		/* RTDEV-26385: scroll to end is required after resize*/
		com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
	} else {
		throw new Error("Element is not exist.");
	}
};

/**
 * Convert expression string to the acceptable css value
 *
 * @INFO Using eval function in this function is safe because In #parseStyleExpression function we are looking for key
 * words which we are expecting from string expression and if text from the expression does not contain the keywords
 * that we expect, then we stop the function.
 *
 * @private
 * @param {attr}  attr - attribute name
 * @param {string}  expression - attribute string expression in specific format: '[element_name].[attribute_name] [operation_sign] [number]'
 * (i.e. "RightFrame.height - 50" , "txtInput.width + 10 - Skin.width", "LeftFrame.top * 3 - Skin.top + window.inqFrame.pathToSomeAttrValue"  etc.)
 * @this Application
 * @return {number} - executed number representation of the passed expression
 */
Application.prototype.parseStyleExpression = function(attr, expression) {
	if (expression.indexOf(".") < 0) {
		throw new Error("Unknown expression format for " + attr + " attribute");
	}
	/** @type {Array} */
	var expArray = expression.split(" ");

	for (var i=0; i < expArray.length; i++) {
		/** @type {string} */
		var value = expArray[i];

		if (value.indexOf(".") > 0) {// check if expression contains path to element(i.e. "RightFrame.height")
			expArray[i] = com.inq.ui.CommandParser.evaluateSymbolicReference(value);
		}
	}
	try {
		var ret;
		if (com.inq.flash.client.control.FlashPeer.isPolishNotationEnabled()) {
			/** @type {number} */
			ret = com.inq.utils.Util.evalExpression(expArray.join(" "));
		} else {
			ret = com.inq.flash.client.control.FlashPeer.evaluateLegacySettings(expArray.join(" "));
		}
	} catch (e) {
		haxe.Log.trace("Application#parseStyleExpression Invalid attr value");
	}
	return ret;
};

/**
 * getTextInput - Get mxml item from the Application instance
 *
 * $type TFun([{ name => keyId, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.TextInput,[]))
 * public function getTextInput(keyId:String):TextInput
 * @public
 * @this Application
 * @see getMxmlItem
 * @param {string}  keyId - the id of the mxml item that is requested
 * @return {com.inq.ui.TextInput} - the item as a TextInput object
 */
Application.prototype.getTextInput = function(keyId) {
	return this.getMxmlItem(keyId);
};

Application.keydownHandler = function(event){

	/**
	 * In our code we support sending message by press "Enter" key.
	 * Keyboard functionality is a requirement per WCAG 2.1.1.
	 *
	 * We implement this functionality by adding event listener with event type "keyPress",
	 * in {@link com.inq.flash.client.chatskins.SkinControl.startKeyListener()} function, and this listener call
	 * {@link com.inq.flash.client.chatskins.SkinControl.onKeyPress()}.
	 *
	 * As far as we know keypress occurs immediately after keydown event.
	 * But some clients (like Bell Canada) have they own listeners for this event, which do preventDefault(),
	 * and in this case our listener on "keyPress" do not work, to avoid such behavior we call stopPropagation().
	 *
	 * Described situation relevant only for "div" skins.
	 */
	event.stopPropagation();

	// Close email form if open upon ESC key down and return.
	if (com.inq.flash.client.chatskins.EmailMgr.emailCanvas != null) {
		if (com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getVisible() && event.keyCode == com.inq.ui.Keyboard.ESCAPE) {
			com.inq.flash.client.chatskins.EmailMgr.actionCancelEmail();
			return false;
		}
	}

    // If ESC key is pressed and escToClose is configured as true in mxml, close chat as requested by ComCast
    if(event.keyCode == com.inq.ui.Keyboard.ESCAPE && com.inq.utils.Util.getConfig("escToClose",false)){
		if (com.inq.utils.Capabilities.isChrome()) {
			window.setTimeout(function() {
				com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
			}, 0);
		} else {
			com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
		}
		return false;
	}

	// Close chat with ESC only if chat is not initiate yet.
	if (event.keyCode == com.inq.ui.Keyboard.ESCAPE
		&& com.inq.utils.Util.getConfig("escToCloseWhenNoChat", false)
		&& com.inq.flash.client.chatskins.SkinControl.timerTimeout != null) {
		/*
		 * RTDEV-14245 - This is a Chrome only issue.  For some unknown reason, if it only works
		 * if the <actionBtnCloseChat> function is executed inside window.setTimeout even though
		 * the delay is 0 second.  Otherwise, Chrome will cancel the "requestC2CImage" request.  Please see
		 * comments in the ticket for details.
		 */
		if (com.inq.utils.Capabilities.isChrome()) {
			window.setTimeout(function() {
				com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
			}, 0);
		} else {
			com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
		}
		return false
	}
};
/**
 * getCanvas - Get mxml item from the Application instance
 *
 * $type TFun([{ name => keyId, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.Canvas,[]))
 * public function getCanvas(keyId:String):Canvas
 * @public
 * @this Application
 * @see getMxmlItem
 * @param {string}  keyId - the id of the mxml item that is requested
 * @return {com.inq.ui.Canvas} - the item as a Canvas object
 */
Application.prototype.getCanvas = function(keyId) {
	return this.getMxmlItem(keyId);
};


/**
 * getButton - Get mxml item from the Application instance
 *
 * $type TFun([{ name => keyId, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.Button,[]))
 * public function getButton(keyId:String):Button
 * @public
 * @this Application
 * @see getMxmlItem
 * @param {string}  keyId - the id of the mxml item that is requested
 * @return {com.inq.ui.Button} - the item as a Button object
 */
Application.prototype.getButton = function(keyId) {
	return this.getMxmlItem(keyId);
};


/**
 * getMxmlItem - Get mxml item from the Application instance
 *
 * $type TFun([{ name => keyId, t => TInst(String,[]), opt => false }],TDynamic(null))
 * public function getMxmlItem(keyId:String):Dynamic
 * @public
 * @this Application
 * @see getButton, getCanvas, getTextInput
 * @param {string}  keyId - the id of the mxml item that is requested
 * @return {null} - the item as a generic object
 */
Application.prototype.getMxmlItem = function(keyId) {
	return this[keyId];
};


/**
 * setMxmlItem
 * setTextInput - Set mxml item into the Application instance
 *
 * $type TFun([{ name => container, t => TInst(com.inq.ui.Container,[]), opt => false }],TEnum(Void,[]))
 * public function setMxmlItem(container:Container):Void
 * @public
 * @this Application
 * @see getMxmlItem
 * @param {com.inq.ui.Container}  container
 * @return {void}
 */
Application.prototype.setMxmlItem = function(container) {
	/** @type {string} */
	var keyId = container.getID();
	this[keyId] = container;
};

/**
 * Returns the array of activated com.inq.ui.XFrame objects.
 *
 * @returns {Array.<com.inq.ui.XFrame>}
 */
Application.prototype.getXFrameItems = function () {
	var items = [];
	for (var key in this) {
		var item = this[key];
		if (js.Boot.__instanceof(item, com.inq.ui.XFrame)) {
			items.push(item);
		}
	}
	return items;
}

Application.prototype.cleanUp = function () {
	com.inq.utils.Capabilities.UnbindListener(this.getParentBody(), "keydown", Application.keydownHandler);
};

Application.prototype.closeMxmlItems = function () {
	var obj = {};
	for (var key in this) {
		if (obj.hasOwnProperty.call(this,key)) {
			var item = Application.application[key];
			if (js.Boot.__instanceof(item, com.inq.ui.Container)) {
				item.cleanUp();
				item = null;
			}

		}
	}
};
/**
 * getClearImage - Get the clear image from the Application instance
 *
 * $type TFun([],TInst(String,[]))
 * public function getClearImage():String
 * @public
 * @this Application
 * @return {string} - string path of the image
 */
Application.prototype.getClearImage = function() {
	return this["clearImage"];
};

/**
 * RTDEV-8340
 * @public
 * @return {Window}
 */

Application.prototype.getPanelWindow = function() {
	return this.panelWindow;
}
/**
 * RTDEV-8340
 * @public
 * @param {Window}
 */
Application.prototype.setPanelWindow = function(val)
{
	this.panelWindow = val;
};

/**
 * touching on the  titlebar logo causing parent page to scroll. Fixed the issue by eating the touchevent
 * @return {HTMLElement}
 */
Application.prototype.getTitleBarElement = function(){
	return (this.titleBar?this.titleBar._div:null);
};

Application.onTitleBarTouch = function(ev) {
	ev.preventDefault();
}

/**
 * Restart timer to close not started chat. If parameters didn't set, then restart timer with parameters from previously run
 *
 * @param timeout time in seconds before not started chat will be closed
 * @param actionOnTimeout another action for timer after timeout
 */
Application.prototype.restartTimer = function(timeout, actionOnTimeout) {
	com.inq.flash.client.chatskins.SkinControl.restartTimer(timeout, actionOnTimeout);
};

/**
 * Returns the boolean flag meaning that chat application can communicate with the chat router
 * (connected flag should be 'true' and there is no connection issue).
 * @return {boolean}
 */
Application.prototype.isConnected = function() {
	if (this.applicationController) {
		return this.applicationController.isConnected() && !this.applicationController.isSendMessageFail();
	} else {
		return false;
	}
};

/**
 * Returns the boolean flag meaning that chat has been accepted by an agent.
 * One of the use of this function is to determine whether we allow the customer to send email. RTDEV-18119
 * @return {boolean}
 */
Application.prototype.isAgentAssigned = function() {
	if (this.applicationController) {
		return this.applicationController.isAgentAssigned();
	} else {
		return false;
	}
}


/**
 * Returns boolean indicating whether it is a live or virtual agent chat.
 * @returns {boolean}
 */
Application.prototype.isVirtualAgent = function () {
	// The "va" value is set from ChatAuthorizedMessageHandler if the chatroom member type is "virtual_agent"
	return com.inq.flash.client.control.PersistenceManager.GetValue(VIRTUAL_AGENT);
}

Application.prototype.fireMxmlEvent = function(event) {
	com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler(event);
};
Application.prototype.updateCustomerName = function(customerName) {
	com.inq.flash.client.chatskins.SkinControl.updateCustomerName(customerName);
	com.inq.flash.client.data.Chat.prototype.setUsername(customerName);
};

Application.prototype.setFocusOnInputField = function() {
	com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
};

Application.prototype.setTextFieldfocus = function() {
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if(ti){
		ti.setFocus(true);
	}
};

/** @private @type {com.inq.net.URLLoader} */
Application.prototype.loaderSkin = null;
/** @private @type {string} */
Application.prototype.skinpath = null;
/** @private @type {string} */
Application.prototype.imgpath = null;
/** @private @type {string} */
Application.prototype.path = null;
/** @type {com.inq.ui.Image} */
Application.prototype.titlebar = null;
/** @type {null} */
Application.prototype.stg = null;
/** @type {com.inq.ui.Stage} */
Application.prototype.stage = null;
/** @type {com.inq.ui.Screen} */
Application.prototype.screen = null;
/** @type {string} */
Application.prototype.currentState = null;
/** @type {com.inq.utils.Dictionary} */
Application.prototype.parameters = null;
/** @private @type {com.inq.utils.Area} */
Application.prototype.area = null;
/** @private @type {Array} */
Application.prototype.onApplicationControllerInitializedHandlers = null;
/** @private @type {com.inq.flash.client.control.ApplicationController} */
Application.prototype.applicationController = null;
/** @private @type {null} */
Application.prototype.chatData = null;
/** @type {boolean} */
Application.prototype.initialized = null;
/** @type {string} */
Application.prototype.url = null;
/** @type {Application} */
Application.prototype.__class__ = Application;
/** @private @type {boolean} */
Application.__initTrace = Application._initTrace();

/** @private @type {boolean} */
Application.hasRun = false;

/** @private @type {boolean} */
Application.isPersistent = false;
/**
 * @type {number}
 */
Application.clientBodyMarginTop = 0;

/** @type {Application} */
Application.application = null;

/** @private @type {boolean} */
Application.resizable = true;

/** @private @type {boolean} */
Application.draggable = true;

/** @private @type {number} */
Application.minWidth = 250;

/** @private @type {number} */
Application.minHeight = 150;

/** @private @type {com.inq.utils.Area} */
Application.dragArea = com.inq.utils.Capabilities.getDefaultResizeArea();

/** @private @type {number} */
Application.zIndexResize = 9999999;

/** @private @type {string} */
Application.lWR = "launchWhenReady";

/** @private @type {number} */
Application.popoutStageWidth = -1;

/** @private @type {number} */
Application.popoutStageHeight = -1;

/** @private @type {boolean} */
Application.setFocusToBtnCloseOnOpen = false;

/** @type {number} */
Application.DEFAULT_WIDTH_VAL = 400;

/** @type {number} */
Application.DEFAULT_HEIGHT_VAL = 300;

/**
 * RTDEV-16228
 * The problem of this ticket is caused by the following element defined in the customer's page:
 *
 * <main class="main padding-top-zero border-vert" style="margin-top: 37px; min-height: 630px;">
 *
 * The <margin-top> style's property will cause our skin body shifted 37px to the top. To fix this problem, we need to
 * obtain the margin-top value and compensate for it in our code.  Since we have no access to customer's page, we will
 * define the value in our skin file and access it in our code.
 * The following variable will be read from the property <parentDocumentBodyMarginTop> defined in the skin file.  The
 * skin file for this ticket is <vzt-mobile-v1.mxml>
 */
/** @private @type {number} */
Application.parentDocumentBodyMarginTop = 0;

Application.savePage = { bodyPosition: null };
